import React, {Fragment} from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';

const ASSETS_BASE = /localhost/.test(window.location.href) ? "" : "/global17/bundles/games/dist";

export default class DifferencesGame extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			logged: false,
			alreadyPlayed: false,
			remainingTime: document.getElementById("differences-game-canvas").getAttribute("maxTime") || 90,
			remainingClicks: document.getElementById("differences-game-canvas").getAttribute("maxClicks") || 10,
			maxClicks: document.getElementById("differences-game-canvas").getAttribute("maxClicks") || 10,
			started: false,
			ended: false,
			winner: false,
			spottedDifferences: [],
			differences: JSON.parse(document.getElementById("differences-game-canvas").getAttribute("differences")),
			img1: "",
			img2: "",
			sponsorImage: document.getElementById("differences-game-canvas").getAttribute("sponsor") || "",
		}
	}

	componentDidMount() {
		// load game images
		const img1 = document.getElementById("difference_image_1").innerHTML,
			img2 = document.getElementById("difference_image_2").innerHTML;
		const logged = document.getElementById("differences-game-canvas").getAttribute("logged") === "true" ? true : false;
		//const alreadyPlayed =  document.getElementById("differences-game-canvas").getAttribute("alreadyPlayed") === "true" ? true : false;

		this.setState({
			img1, img2, logged, /*alreadyPlayed*/
		}, () => {
			this.state.differences.forEach(difference => {
				const clickableObj = document.getElementById(difference);
				if(clickableObj)
					clickableObj.addEventListener("click", () => this.clickDifference(difference));
			});
			const svg = document.querySelector(".game-image.clickable svg");
			if(svg)
				svg.addEventListener("click", () => this.chance());
			//autostart
			//this.start();
		});

	}

	start() {
		this.setState({started: true}, () => {
			this.state.differences.forEach(difference => {
				const clickableObj = document.getElementById(difference);
				if(clickableObj)
					clickableObj.addEventListener("click", () => this.clickDifference(difference));
			});
			const svg = document.querySelector(".game-image.clickable svg");
			if(svg)
				svg.addEventListener("click", () => this.chance());
			setInterval(() => {
				if(this.state.started && !this.state.ended)
					if(this.state.remainingTime === 1)
						this.setState({
							remainingTime: this.state.remainingTime - 1,
							started: true,
							ended: true
						}, () => {
							this.end();
						});
					else
						this.setState({
							remainingTime: this.state.remainingTime - 1
						});
			}, 1000);
		});
	}

	end(win = false) {
		let winner = win;
		this.setState({ winner }, () => {
			this.registerPartecipant(winner);
		});
	}

	clickDifference(difference) {
		const { spottedDifferences } = this.state;
		if(!spottedDifferences.includes(difference)) {
			spottedDifferences.push(difference)
			const elem = document.getElementById(difference);
			elem.style.opacity = "1";
			this.setState({spottedDifferences: spottedDifferences}, () => {
				if(this.state.spottedDifferences.length === this.state.differences.length) {
					this.setState({
						started: true,
						ended: true
					}, () => {
						this.end(true);
					});
				}
			});
		}
	}

	chance() {
		const { remainingClicks } = this.state;
		this.setState({ remainingClicks: remainingClicks - 1 }, () => {
			if(this.state.remainingClicks === 0)
				this.setState({
					started: true,
					ended: true
				}, () => {
					this.end();
				});
		});
	}

	shareOn(platform) {
		const url = window.location.href;
		switch(platform) {
			case "facebook": window.open('http://www.facebook.com/sharer.php?u='+encodeURIComponent(url)+'&t='+encodeURIComponent('Trova anche tu le differenze!'),'sharer','toolbar=0,status=0,width=626,height=436');
				break;
			case "twitter": window.open("https://twitter.com/home?status="+encodeURIComponent(url))
				break;
			case "whatsapp": window.location.href = "whatsapp://send?text=" + encodeURIComponent(url)
				break;
			case "download": window.open(memeUrl)
				break;
		}
	}

	registerPartecipant(win) {
		axios.post(`?winner=${win ? 1 : 0}`).then(response => {
			console.log(response.data);
		}).catch(e => console.log(e));
	}

	render() {

		const { remainingTime, started, ended, maxClicks, remainingClicks, differences, spottedDifferences, img1, img2, winner, sponsorImage, logged, alreadyPlayed } = this.state;

		return (
			<Fragment>

				{/* HEADER */}
				<div className={"header"}>
					<div className={"container"}>
						<div className={"logo"}>
							<img src={sponsorImage} alt={"Sponsor"} />
						</div>
						<div className={"flex j-center a-center"}>
							<div className={"time flex j-center a-center"}>
								<img className={"time-icon"} src={ASSETS_BASE + "/images/time.png"} />
								<span className={"time-remaining"}>
									TEMPO RESIDUO <strong><Timer started={started} remainingTime={remainingTime} /></strong>
								</span>
							</div>
							<div className={"click flex j-center a-center"}>
								<img className={"click-icon"} src={ASSETS_BASE + "/images/click.png"} />
								<span className={"click-remaining"}>
									CLICK <strong>{remainingClicks}/{maxClicks}</strong>
								</span>
							</div>
							<div className={"click flex j-center a-center"}>
								<img className={"click-icon"} src={ASSETS_BASE + "/images/differencesicon.png"} />
								<span className={"click-remaining"}>
									DIFFERENZE <strong>{spottedDifferences.length}/{differences.length}</strong>
								</span>
							</div>
						</div>
					</div>
				</div>

				{/* GAME CANVAS */}
				<div className={"game-canvas"}>

					{alreadyPlayed && (
						<div className={"container"} style={{textAlign: "center", padding: "2em 0"}}>
							<h4 style={{color: "#ffffff", fontWeight: "bold", marginTop: "2em", textAlign: "center"}}>Hai già partecipato a questo gioco!</h4>
						</div>
					)}

					{!started && !ended && !logged && !alreadyPlayed && (
						<div className={"container"} style={{textAlign: "center", padding: "2em 0"}}>
							<button style={{margin: "0 auto", padding: "1em 3em", background: "#EA2328", color: "#fff", width: "100%", fontSize: "18px", whiteSpace: "normal"}} className={"btn"} onClick={() => window.location.href = `/authentication?ref=${window.location.pathname}`} >
								Accedi / Registrati per giocare!
							</button>
						</div>
					)}

					{!started && !ended && logged && !alreadyPlayed && (
						<div className={"container"} style={{textAlign: "center", padding: "2em 0"}}>
							<button style={{margin: "0 auto", padding: "1em 3em", background: "#EA2328", color: "#fff", width: "100%", fontSize: "18px", whiteSpace: "normal"}} className={"btn"} onClick={() => this.start()} >
								Clicca per far partire il tempo e iniziare a giocare!
							</button>
						</div>
					)}

					{started && !ended && !alreadyPlayed && (
						<div className={"container"}>
							<h4 className={"d-none d-md-block"}>Clicca su questa immagine per trovare le differenze</h4>
							<div className={"row diff-images-wrapper w-100"}>
								<div className={"col-md-6 col-xs-12"}>
									<div className={"game-image"} dangerouslySetInnerHTML={{__html: img1 }} />
								</div>
								<div className={"col-md-6 col-xs-12"}>
									<h4 className={"d-md-none d-xs-block"} style={{textAlign: "left"}}>Clicca su questa immagine per trovare le differenze</h4>
									<div className={"game-image clickable"} dangerouslySetInnerHTML={{__html: img2 }} />
								</div>
							</div>
						</div>
					)}

					{started && ended && winner && !alreadyPlayed && (
						<div className={"game-result-banner container"}>
							<h3>WOW, SEI UN LAMPO!</h3>
							<p>Hai trovato tutte le differenze nel tempo a disposizione. Grazie per aver partecipato, ecco il codice sconto da utilizzare su purinashop.it:</p>
							<h3 style={{width: "100%", textAlign: "center"}}>Gourmet10</h3>
							<p>Il buono sconto ti dà diritto a uno sconto del 10% sull’acquisto di prodotti Gourmet sul sito Purinashop.it, il buono sconto è valido dal 15/02/2021 al 05/03/2021. </p>
							<button onClick={() => window.location.href = "https://www.purinashop.it/brand/gatto/gourmet"} className={"btn play-game-button"}>Vai al Purinashop</button><br/>
							<button onClick={() => window.location.reload()} className={"btn play-game-button"}>Gioca di nuovo</button><br/>
							<img style={{maxWidth: "100%"}} src={ASSETS_BASE + "/images/cat.png"} />
						</div>
					)}

					{started && ended && !winner && !alreadyPlayed && (
						<div className={"game-result-banner container"}>
							<h3>GRAZIE PER AVER GIOCATO CON NOI!</h3>
							<p>Ecco il codice sconto da utilizzare su purinashop.it:</p>
							<h3 style={{width: "100%", textAlign: "center"}}>Gourmet10</h3>
							<p>Il buono sconto ti dà diritto a uno sconto del 10% sull’acquisto di prodotti Gourmet sul sito Purinashop.it, il buono sconto è valido dal 15/02/2021 al 05/03/2021. </p>
							<button onClick={() => window.location.href = "https://www.purinashop.it/brand/gatto/gourmet"} className={"btn play-game-button"}>Vai al Purinashop</button><br/>
							<button onClick={() => window.location.reload()} className={"btn play-game-button"}>Gioca di nuovo</button><br/>
							<img style={{maxWidth: "100%"}} src={ASSETS_BASE + "/images/cat.png"} />
						</div>
					)}

				</div>

			</Fragment>
		);
	}

}

const Timer = ({ remainingTime }) => {
	const mins = Math.floor(remainingTime/60) < 10 ? `0${Math.floor(remainingTime/60)}` : Math.floor(remainingTime/60);
	const secs = (remainingTime%60) < 10 ? `0${(remainingTime%60)}` : (remainingTime%60);
	return (
		<Fragment>
			{mins}:{secs}
		</Fragment>
	);
}

document.addEventListener("DOMContentLoaded", () => {
	const mountPoint = document.getElementById("differences-game-canvas");
	if(mountPoint)
		ReactDOM.render(<DifferencesGame />, mountPoint);
});
